import { getItemOrFirstElement } from '@vista-digital/occ-domain';
import { convertToCamelCase } from '@vista-digital/utilities';
import { FieldValidationError } from '../../types/form/field-validation-error';
/**
 * Parses and returns the display text for a FormFieldError.
 * displayText keys contain a single field per validation error type in the format: displayText[`${validationError}Message`]
 */
export const getFormFieldErrorMessage = (error, displayText, i18n, config, templateParameters) => {
    const firstError = getItemOrFirstElement(error);
    if (!firstError)
        return undefined;
    let errorDisplayText = displayText[`${convertToCamelCase(firstError)}Message`] || error;
    if (error === FieldValidationError.Length) {
        errorDisplayText = getFormattedLengthErrorMessage(config, errorDisplayText, i18n);
    }
    if (error === FieldValidationError.Range) {
        errorDisplayText = getFormattedRangeErrorMessage(config, errorDisplayText, i18n);
    }
    if (templateParameters) {
        errorDisplayText = i18n.displayTextLabel(errorDisplayText, templateParameters);
    }
    return errorDisplayText;
};
export const getFormattedLengthErrorMessage = (fieldConfig, errorText, i18n) => {
    if (!fieldConfig || !isRestrictedLengthFieldValidationConfig(fieldConfig))
        return errorText;
    const templateParameters = {
        minLength: fieldConfig.minLength,
        maxLength: fieldConfig.maxLength
    };
    return i18n.displayTextLabel(errorText, templateParameters);
};
export const getFormattedRangeErrorMessage = (fieldConfig, errorText, i18n) => {
    var _a, _b;
    if (!fieldConfig || !isRangeFieldValidationConfig(fieldConfig))
        return errorText;
    const templateParameters = {
        min: (_a = fieldConfig.range) === null || _a === void 0 ? void 0 : _a.min,
        max: (_b = fieldConfig.range) === null || _b === void 0 ? void 0 : _b.max
    };
    return i18n.displayTextLabel(errorText, templateParameters);
};
const isRestrictedLengthFieldValidationConfig = (config) => {
    return 'minLength' in config || 'maxLength' in config;
};
const isRangeFieldValidationConfig = (config) => {
    return 'range' in config;
};
//# sourceMappingURL=form-field-utils.js.map